import Chart from "pro-features/components/Chart/src/Chart";

import pickBy from "lodash/pickBy";
import type { FC } from "react";

interface INgHighchartsOptions {
    options?: Highcharts.Options;
    series?: Highcharts.SeriesOptionsType[];
}

interface INgToReactChartProps {
    highchartsNgConfig: INgHighchartsOptions;
    afterRender?: (a?) => {};
    chartIdForAnnotations?: string;
    setChart?: (chartsRef) => void;
}

function highchartsNgToVanilla(highchartsNgConfig: INgHighchartsOptions): {
    data: Highcharts.SeriesOptionsType[];
    config: Highcharts.Options;
} {
    return {
        data: highchartsNgConfig.series,
        config: {
            ...pickBy<any>(highchartsNgConfig.options, (v, k) => k !== "series"),
            ...pickBy<any>(highchartsNgConfig, (v, k) => k !== "series"),
        },
    };
}

export const NgToReactChart: FC<INgToReactChartProps> = ({
    highchartsNgConfig,
    afterRender,
    chartIdForAnnotations,
    setChart,
}) => {
    if (!highchartsNgConfig || !highchartsNgConfig.options || !highchartsNgConfig.series) {
        return null;
    }

    const setReactHC = (reactHC) => {
        setChart?.(reactHC);
    };

    const { config, data } = highchartsNgToVanilla(highchartsNgConfig);

    return (
        <Chart
            type={config.chart.type}
            data={data}
            config={config}
            afterRender={afterRender}
            chartIdForAnnotations={chartIdForAnnotations}
            setChart={setReactHC}
        />
    );
};
